module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }]
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.searchPanelOpened),
      expression: "!searchPanelOpened"
    }],
    staticClass: "btn btn-confirm btn-xs btn-search",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleSearchPanel()
      }
    }
  }, [_vm._v("Szukaj")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchPanelOpened),
      expression: "searchPanelOpened"
    }],
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedFilters.text),
      expression: "selectedFilters.text"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nazwa produktu"
    },
    domProps: {
      "value": (_vm.selectedFilters.text)
    },
    on: {
      "keyup": _vm.search,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedFilters, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', _vm._l((_vm.types), function(text, key) {
    return _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedFilters.types),
        expression: "selectedFilters.types"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.selectedFilters.types) ? _vm._i(_vm.selectedFilters.types, key) > -1 : (_vm.selectedFilters.types)
      },
      on: {
        "click": _vm.search,
        "change": function($event) {
          var $$a = _vm.selectedFilters.types,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.selectedFilters, "types", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.selectedFilters, "types", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.selectedFilters, "types", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(text))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearNotificationsFilter()
      }
    }
  }, [_vm._v("Zamknij")])])]), _vm._v(" "), (_vm.items.length > 0) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n            Wyników " + _vm._s(_vm.count) + ", pokazane " + _vm._s(_vm.items.length) + "\n            "), _c('br'), _vm._v("\n            Strona\n\n            "), (_vm.page > 0) ? _c('span', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changePage(false)
      }
    }
  }, [_vm._v("poprzednia")])]) : _vm._e(), _vm._v("\n\n            " + _vm._s(_vm.page + 1) + "\n\n            "), (_vm.items.length > 0 && _vm.items.length == _vm.limit) ? _c('span', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changePage(true)
      }
    }
  }, [_vm._v("następna")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.items.length == 0) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("Brak powiadomień")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/loader.gif")
    }
  })]), _vm._v(" "), (_vm.items.length > 0) ? _c('ul', _vm._l((_vm.items), function(notification) {
    return _c('li', [_c('div', {
      staticClass: "well well-sm"
    }, [_c('a', {
      staticClass: "product-name",
      attrs: {
        "href": "#",
        "title": notification.product_name + ' (' + notification.category_name + ')'
      },
      on: {
        "click": function($event) {
          return _vm.showNotification(notification)
        }
      }
    }, [_vm._v(_vm._s(notification.text))]), _vm._v(" "), (_vm.types[notification.type]) ? _c('small', [_vm._v(_vm._s(_vm.types[notification.type]))]) : _vm._e()])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask",
    attrs: {
      "id": "notification-modal"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('notification', {
    attrs: {
      "data": _vm.selectedNotification,
      "types": _vm.types
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-confirm btn-sm",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Zamknij")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74314787!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotificationPanel.vue
// module id = 1324
// module chunks = 2